@import "src/styles/common/index.scss";
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin: 0;
}

.defaultBold {
  b,
  strong {
    @include font-bold;
  }
}

.h1 {
  @extend .defaultBold;
  font-size: 4rem;
  line-height: 4.5rem;
  text-transform: uppercase;
  @include font-regular-oswald;
  @include mobile {
    font-size: 2.25rem;
    line-height: 2.75rem;
  }
}

.h2 {
  @extend .defaultBold;
  font-size: 3.5rem;
  line-height: 4rem;
  @include font-bold;
  @include mobile {
    font-size: 1.875rem;
    line-height: 2.375rem;
  }
}

.h3 {
  @extend .defaultBold;
  font-size: 2.625rem;
  line-height: 3.125rem;
  @include font-bold;
  @include mobile {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

.h4 {
  @extend .defaultBold;
  font-size: 1.875rem;
  line-height: 2.375rem;
  @include font-bold;
  @include mobile {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

.h5 {
  @extend .defaultBold;
  font-size: 1.5rem;
  line-height: 2rem;
  @include font-bold;
  @include mobile {
    font-size: 1.125rem;
    line-height: 1.625rem;
  }
}

.h6 {
  @extend .defaultBold;
  font-size: 1.125rem;
  line-height: 1.625rem;
  @include font-bold;
  @include mobile {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.p1 {
  @extend .defaultBold;
  @include font-regular;
  font-size: 1.125rem;
  line-height: 1.625rem;
  @include mobile {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.p2 {
  @extend .defaultBold;
  @include font-regular;
  font-size: 1rem;
  line-height: 1.5rem;
  @include mobile {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

.p3 {
  @extend .defaultBold;
  @include font-regular;
  font-size: 0.875rem;
  line-height: 1.125rem;
  @include mobile {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

.p4 {
  @extend .defaultBold;
  @include font-regular;
  font-size: 0.75rem;
  line-height: 1rem;
  @include mobile {
    font-size: 0.625rem;
    line-height: 0.875rem;
  }
}

.p5 {
  @extend .defaultBold;
  @include font-regular;
  font-size: 0.5rem;
  line-height: 0.5rem;
  @include mobile {
    font-size: 0.5rem;
    line-height: 0.5rem;
  }
}

.afterLabel {
  &:after {
    content: ":";
    display: inline-block;
    padding: 0px 2px;
  }
}

.label {
  @extend .defaultBold;
  @include font-regular;
  font-size: 0.625rem;
  line-height: 0.75rem;
  a,
  span {
    @include font-regular;
  }
  p {
    margin: 10px 0;
  }
  ul {
    padding: 0;
  }
}

.defaultTextColor {
  color: $white;
}

.blackTextColor {
  color: $black;
}

.primaryTextColor {
  color: $tile;
}

.secondaryTextColor {
  color: $dark-green;
}

.graphiteTextColor {
  color: $smoke-white;
}

.blueTextColor {
  color: $selected-blue;
}

.regularFont {
  @include font-regular;
}

.normalFont {
  @include font-normal;
}

.mediumFont {
  @include font-medium;
}

.boldFont {
  @include font-bold;
}

.oswaldFont {
  @include font-regular-oswald;
}

.italicFont {
  @include font-italic;
}

.searchHighlightColor {
  background-color: $text-highlight;
  color: $white;
}
